<!-- Maintenance overlay — shown when handshake API is unreachable -->
@if (isServerDown$ | async) {
<app-maintenance-screen></app-maintenance-screen>
}

<!-- <app-billing-plan-expiry-notification></app-billing-plan-expiry-notification> -->
<!-- Routed component view -->
<router-outlet></router-outlet>

<!-- Global loader spinner -->
@if (isLoading | async) {
<app-loader></app-loader>
}

<!-- Show upgrade modal if package expired -->
<app-upgrade-dialog *ngIf="commonService.isPackegeExpired"></app-upgrade-dialog>

<!-- Toast notifications -->
<div class="toast-container">
    <app-toast *ngFor="let toast of toastService.toast$ | async" [toast]="toast"></app-toast>
</div>

@if (modalTrigger.flag) {
<app-chat-bot-modal [isModalOpened]="modalTrigger.flag" (hidePopup)="closeModal(modalTrigger.trigger)"></app-chat-bot-modal>
}


@if(isRemaingNotify){
<app-billing-trial-modal></app-billing-trial-modal>
}

@if(isExpireNotify){
<app-billing-trial-modal [title]="'Free Trial Ended'" [subTitle]="'Your free trial has ended. Please upgrade your plan to continue performing functions.'" [is_showBack]="false">


</app-billing-trial-modal>
}